// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a92520bc","453":"40c4ee5e","455":"f246f38f","977":"b398b6eb"}[chunkId] + ".chunk.js";
};